import {Stack} from '@mui/material'

const ButtonGroup = ({children, className}) => (
  <Stack
    aria-label='Action buttons'
    className={className}
    direction={{mobileSm: 'column-reverse', mobileLg: 'row'}}
    justifyContent='row'
    gap={2}
    role='group'
    sx={{
      alignItems: 'center',
      justifyContent: {
        mobileSm: 'center',
        mobileLg: 'flex-start'
      }
    }}>
    {children}
  </Stack>
)

export default ButtonGroup
